import { reportError } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/reportService';

const CHUNK_RELOAD_KEY = 'chunk-load-reloaded-v1';
// eslint-disable-next-line import/prefer-default-export
export const retryLoadableImport = (importFn, retries = 3, delay = 800) => {
    let attemptsLeft = retries;
    return new Promise((resolve, reject) => {
        function attempt() {
            importFn()
                .then(resolve)
                .catch((error) => {
                    const isChunkError = error && (error.name === 'ChunkLoadError' || /Loading chunk [\d]+ failed/i.test(error.message) || /ChunkLoadError/i.test(error.message));
                    if (isChunkError && attemptsLeft > 0) {
                        attemptsLeft -= 1;
                        setTimeout(attempt, delay);
                        return;
                    }
                    error.customMessage = `Neuspješan import i nakon ${retries} pokušaja, ide refresh nakon kojega se ne bi trebao ponoviti log sa istim podacima (POTREBNO PREGLEDATI !).`;
                    reportError(error);
                    if (isChunkError && typeof window !== 'undefined' && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
                        sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
                        setTimeout(() => {
                            window.location.reload();
                        }, 200);
                    }
                    reject(error);
                });
        }
        attempt();
    });
};
